/**
 * Created by JasonChou on 17/6/13.
 */
import * as toast from './toastUtils'

Object.assign(global, toast);
Object.assign(global, {
    isInWsdkApp: () => {
        return decodeURIComponent(navigator.userAgent).match(/纹身大咖|okttp|Bshopkeeper/)
    }
});




// WEBPACK FOOTER //
// ./src/utils/global.js